import { map as Rmap } from "ramda";
import { JSConn } from "@/utilities/js-conn";
import { format, formatDistance } from "date-fns";
import { BLANK_EDITOR_DOCUMENT } from "@/constants";
import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay";
import { Editor, EditorContent } from "tiptap";
import { Placeholder } from "tiptap-extensions";

export default {
  name: "workOrderNotes",
  components: {
    TipTapDisplay,
    EditorContent,
  },
  data() {
    return {
      note: {
        content_json: BLANK_EDITOR_DOCUMENT,
        created_at: null,
        work_order_id: null,
      },
      editor: null,
    };
  },
  mounted() {
    this.editor = new Editor({
      autoFocus: true,
      extensions: [
        new Placeholder({
          emptyClass: "is-empty",
          emptyNodeText: "Write a note...",
          showOnlyWhenEditable: true,
        }),
      ],
    });
  },
  computed: {
    workOrderNotes: function() {
      const apiNotes = this.$store.getters.workOrderNotes;
      const rightNow = new Date();
      return Rmap(nt => {
        const createdAt = new Date(nt.created_at);
        const humanizedDate = format(createdAt, "MMMM d, yyyy, h:mm a");
        const time_ago_in_words = formatDistance(rightNow, createdAt) + " ago";
        return {
          ...nt,
          humanized_created_at: humanizedDate,
          time_ago_in_words: time_ago_in_words,
        };
      }, apiNotes);
    },
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
  },
  methods: {
    submitNote(evt) {
      evt.preventDefault();
      this.note.content_json = this.editor.getJSON();

      const jsConn = new JSConn();
      const rightNow = new Date();

      jsConn.formParams = {
        content_json: this.note.content_json,
        work_order_id: this.workOrder.id,
        created_at: rightNow,
      };

      this.$store
        .dispatch("createWorkOrderNote", jsConn)
        .then(() => {
          this.note.content_json = BLANK_EDITOR_DOCUMENT;
          this.editor.setContent(BLANK_EDITOR_DOCUMENT);
          this.$nextTick(() => this.editor.focus());
          // reload the data
          // this can be changed to only reload the notes and patch them
          // into the store
          // for right now, just reload the entire work order because that
          // code is already written
          return Promise.resolve();
        })
        .then(() => {
          this.$emit("notesChanged");
        });
    },
  },
};
